import { Component, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { CommonService } from './shared/common.service';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import { StorageService, StorageKey } from '../app/shared/storage.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { UserLayoutService } from './layouts/user-layout/user-layout.service';
import { OrganizationEnumModel } from './shared/constant/organization.model';

declare var gtag: Function;
declare var googleTranslateElementInit: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {

    @HostListener('document:keydown.enter', ['$event'])
    preventEnterSubmit(event: KeyboardEvent) {
        if ((event.target as HTMLElement).tagName === 'INPUT') {
            event.preventDefault(); // Stop form submission on Enter
        }
    }

    constructor(
        private http: HttpClient,
        private router: Router,
        private cookieService: CookieService,
        private commonService: CommonService,
        private spinner: NgxSpinnerService,
        public userLayoutService: UserLayoutService,
        public storageService: StorageService
    ) { }

    ngOnInit() {
        this.trackTranslation();
        this.loadGoogleMaps();
    }

    ngAfterViewInit(): void {
        this.loadGoogleTranslate();
    }

    loadGoogleTranslate() {
        if (!document.querySelector('script[src="//translate.google.com/translate_a/element.js"]')) {
            let script = document.createElement('script');
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.type = 'text/javascript';
            document.body.appendChild(script);
        } else {
            googleTranslateElementInit();
        }
    }

    trackTranslation() {
        const observer = new MutationObserver(() => {
            const lang = document.documentElement.lang;
            this.sendToGA4(lang);
        });

        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
    }

    sendToGA4(language: string) {
        gtag('event', 'language_change', {
            event_category: 'Translation',
            event_label: language
        });
    }

    private loadGoogleMaps(): Promise<void> {
        return new Promise((resolve, reject) => {
            if ((window as any).google && (window as any).google.maps) {
                resolve(); // Already loaded
                return;
            }
            const organizationAttributes = JSON.parse(localStorage.getItem('organizationAttributes'));
            const googlemapapiKey = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.GoogleMapAPIKey && attr.value == true)?.customValue

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${googlemapapiKey}&libraries=places,marker`;
            script.async = true;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => reject('Google Maps script failed to load');
            document.head.appendChild(script);
        });
    }

}
